import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frente-trabalho',
  templateUrl: './frente-trabalho.component.html',
  styleUrls: ['./frente-trabalho.component.scss'],
})
export class FrenteTrabalhoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
